import Api from '../../../common/services/api';

export const NETWORK_UPDATE_TEAM_USERS = 'network/UPDATE_TEAM_USERS';

export default (teamId, users, team) => async (dispatch, getState) => {
  const { network: { selected } } = getState();

  await Api
    .put(`/v2/networks/${selected}/teams/${teamId}/users`, users);

  return dispatch({
    type: NETWORK_UPDATE_TEAM_USERS,
    teamId,
    users,
    team
  });
};
